import { useState } from "react";
import Layout from "../components/Layout";

export default function Settings() {
  const [vitalsThresholds, setVitalsThresholds] = useState({
    heartRate: 100,
    bloodPressure: "140/90",
    bloodSugar: 7.0,
    temperature: 38.0
  });
  const [normalThresholds, setNormalThresholds] = useState({
    heartRate: 60,
    bloodPressure: "120/80",
    bloodSugar: 5.0,
    temperature: 36.5
  });
  const [emailTemplate, setEmailTemplate] = useState("Dear {{name}}, your appointment is confirmed.");
  const [firebaseKey, setFirebaseKey] = useState("AIzaSyD...YOUR_KEY...");
  const [showIntroForm, setShowIntroForm] = useState(true);

  const handleSave = () => {
    alert("Settings saved (mocked)");
  };

  return (
    <Layout>
      <div className="p-6 space-y-6">
        <h1 className="text-2xl font-bold">Settings</h1>

        <div className="bg-white p-4 rounded shadow space-y-4">
          <h2 className="text-lg font-semibold">Vitals Thresholds</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <label className="flex flex-col">
              Heart Rate Max
              <input type="number" value={vitalsThresholds.heartRate} onChange={(e) => setVitalsThresholds({ ...vitalsThresholds, heartRate: e.target.value })} className="border p-2 rounded" />
            </label>
            <label className="flex flex-col">
              Blood Pressure Max
              <input type="text" value={vitalsThresholds.bloodPressure} onChange={(e) => setVitalsThresholds({ ...vitalsThresholds, bloodPressure: e.target.value })} className="border p-2 rounded" />
            </label>
            <label className="flex flex-col">
              Blood Sugar Max
              <input type="number" step="0.1" value={vitalsThresholds.bloodSugar} onChange={(e) => setVitalsThresholds({ ...vitalsThresholds, bloodSugar: e.target.value })} className="border p-2 rounded" />
            </label>
            <label className="flex flex-col">
              Temperature Max
              <input type="number" step="0.1" value={vitalsThresholds.temperature} onChange={(e) => setVitalsThresholds({ ...vitalsThresholds, temperature: e.target.value })} className="border p-2 rounded" />
            </label>
          </div>
        </div>

        <div className="bg-white p-4 rounded shadow space-y-4">
          <h2 className="text-lg font-semibold">Normal Threshold</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <label className="flex flex-col">
              Heart Rate Normal
              <input
                type="number"
                value={normalThresholds.heartRate}
                onChange={(e) => setNormalThresholds({ ...normalThresholds, heartRate: e.target.value })}
                className="border p-2 rounded"
              />
            </label>
            <label className="flex flex-col">
              Blood Pressure Normal
              <input
                type="text"
                value={normalThresholds.bloodPressure}
                onChange={(e) => setNormalThresholds({ ...normalThresholds, bloodPressure: e.target.value })}
                className="border p-2 rounded"
              />
            </label>
            <label className="flex flex-col">
              Blood Sugar Normal
              <input
                type="number"
                step="0.1"
                value={normalThresholds.bloodSugar}
                onChange={(e) => setNormalThresholds({ ...normalThresholds, bloodSugar: e.target.value })}
                className="border p-2 rounded"
              />
            </label>
            <label className="flex flex-col">
              Temperature Normal
              <input
                type="number"
                step="0.1"
                value={normalThresholds.temperature}
                onChange={(e) => setNormalThresholds({ ...normalThresholds, temperature: e.target.value })}
                className="border p-2 rounded"
              />
            </label>
          </div>
        </div>

        <div className="bg-white p-4 rounded shadow space-y-4">
          <h2 className="text-lg font-semibold">Email Template</h2>
          <textarea
            className="w-full border rounded p-2"
            rows={4}
            value={emailTemplate}
            onChange={(e) => setEmailTemplate(e.target.value)}
          ></textarea>
        </div>

        <div className="bg-white p-4 rounded shadow space-y-4">
          <h2 className="text-lg font-semibold">Firebase Settings</h2>
          <input
            className="w-full border p-2 rounded"
            type="text"
            value={firebaseKey}
            onChange={(e) => setFirebaseKey(e.target.value)}
          />
        </div>

        <div className="bg-white p-4 rounded shadow space-y-2">
          <h2 className="text-lg font-semibold">Patient Intake</h2>
          <label className="flex items-center gap-2">
            <input type="checkbox" checked={showIntroForm} onChange={() => setShowIntroForm(!showIntroForm)} />
            Show patient intake form on first login
          </label>
        </div>

        <button className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700" onClick={handleSave}>
          Save Settings
        </button>
      </div>
    </Layout>
  );
}
